module.exports = __webpack_public_path__ + "static/media/iguodala.32e9f696.jpg";